module.exports = __webpack_public_path__ + "a28e44b0c8ffc7e2d684090868b8d45e.svg";